const checkEmailTransformer = response => ({
  ...response,
  isAllocationPossible:
    response?.clientReallocationStatus?.isClientReAllocationPossible ?? false,
  userId: response?.clientReallocationStatus?.data?.userId ?? response?.data?.Client?.User?.id,
  source: response?.clientReallocationStatus?.data?.clientSource,
})

export default checkEmailTransformer